import { Box } from '@material-ui/core';
import { getUsersByUserId, patchSetTwoFactorRequired, User } from '@nemuru-eng/js-api-client';

import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface RemoveOrAddTwoFactorAuthProps {
  userId: string;
  actionType: UserRowActionType.ADD_TWO_FACTOR_AUTH | UserRowActionType.REMOVE_TWO_FACTOR_AUTH;
  selectedUser: User;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}

export const RemoveOrAddTwoFactorAuth = ({
  actionType,
  userId,
  selectedUser,
  opened,
  setOpened,
  handleClose,
}: RemoveOrAddTwoFactorAuthProps) => {
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const { request, loading } = useRequest();

  const onRemoveOrAddTwoFactorAuth = async () => {
    const twoFactorRequired = actionType === UserRowActionType.ADD_TWO_FACTOR_AUTH ? true : false;
    await request(patchSetTwoFactorRequired, { id: selectedUser.id, twoFactorRequired });
    handleClose();
    revalidate();
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton main loading={loading} onClick={() => onRemoveOrAddTwoFactorAuth()}>
            <Text tId={`${actionType}_BUTTON`} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={actionType} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={`${actionType}_DESCRIPTION`} dynamicDataTexts={[selectedUser.username]} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
